<template>
  <v-row class="table-history">
    <v-col cols="12" class="fill-height">
      <v-card class="fill-height" style="overflow: auto;">
        <v-card-text>
          <v-list dense>
            <v-list-item>
              <v-list-item-content class="board" style="justify-content: center">
                <poker-hand :hh="loadedHH"></poker-hand>

                <v-btn class="share-hand" @click="openAskShareHand(loadedHH)" :disabled="isDisconnected">Share Hand</v-btn>
              </v-list-item-content>
            </v-list-item>
            <v-card-actions>
              <v-row>
                <v-col cols="12" class="d-flex justify-center" style="gap: 10px;">
                  <v-btn color="secondary" :disabled="loadingHand" @click="loadHand(0)">First</v-btn>
                  <v-btn color="primary"
                         @click="loadHand(loadedHH.prev_hand)" :disabled="!loadedHH || !loadedHH.prev_hand || loadingHand">
                    Hand #{{ loadedHH ? loadedHH.prev_hand || loadedHH.handNum - 1 : '?' }}
                  </v-btn>
                  <v-btn color="secondary" :disabled="loadingHand" @click="seeTracker(loadedHH)" v-if="loadedHH">Details</v-btn>
                  <v-btn color="primary"
                         @click="loadHand(loadedHH.next_hand)" :disabled="!loadedHH || !loadedHH.next_hand || loadingHand">
                    Hand #{{ loadedHH ? loadedHH.next_hand || loadedHH.handNum + 1 : '?' }}
                  </v-btn>
                  <v-btn color="secondary" @click="loadHand(-1)" :disabled="loadingHand">Last</v-btn>

                  <v-progress-circular indeterminate v-if="loadingHand" color="primary"></v-progress-circular>

                  <v-spacer></v-spacer>
                  <v-checkbox v-model="followMostRecent" label="Follow Most Recent"></v-checkbox>
                </v-col>
              </v-row>
            </v-card-actions>

            <apexchart type="line" :options="options" :series="series"></apexchart>

            <template v-if="series.length && evDescription">
              <p v-for="k of Object.keys(evDescription)" :key="k"> * {{ evDescription[k] }}</p>
            </template>

          </v-list>
        </v-card-text>
      </v-card>
    </v-col>

    <v-dialog v-model="askTracker" width="600">
      <v-card>
        <v-card-title>Hand # {{ tracker.hand_num }} - {{ tracker.displayID }}</v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <pre style="white-space: pre-wrap">{{ tracker.pokertracker_txt }}</pre>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="askTracker=false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="askShareHand" width="600">
      <v-card>
        <v-card-title>Hand # {{ handSharing.hand_num }} - {{ handSharing.displayID }}</v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              Do you want to share this hand?
            </v-col>
            <v-col cols="12">
              <v-text-field label="Message (Optional)" outlined hide-details v-model="handSharing.message"></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green" @click="shareHand(); askShareHand=false">Share</v-btn>
          <v-btn color="primary" @click="askShareHand=false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-row>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import PokerHand from "./PokerHand";

export default {
  components: {PokerHand},
  data() {
    return {
      RANKS: '__23456789TJQKA',
      SUITS: '_cdhs',

      askTracker: false,
      tracker: {},

      askShareHand: false,
      handSharing: {},

      options: {
        chart: {
          id: 'vuechart-example'
        },
        xaxis: {
          categories: ["Pre-flop", "Flop", "Turn", "River"],
          labels: {
            style: {
              fontSize: '16px'
            }
          },
        },
        yaxis: {
          labels: {
            style: {
              fontSize: '16px'
            },
            formatter: (v) => {
              return `${v}%`;
            }
          },
          min: 0,
          max: 100
        },
        stroke: {
          curve: 'smooth'
        },
        theme: {
          mode: 'dark',
          palette: 'palette1',
        },
        dataLabels: {
          enabled: true,
          style: {
            fontSize: "14px",
            fontFamily: "Helvetica, Arial, sans-serif",
            fontWeight: "bold"
          },
          formatter: (v) => {
            return `${v}%`;
          }
        },
        legend: {
          fontSize: "16px"
        },
        tooltip: {
          style: {
            fontSize: '16px'
          }
        }
      },
      series: [],

      loadingHand: false,
      lastLoadedHand: 0,
      evDescription: ""
    };
  },
  watch: {
    currentHandId() {
      // update ev on hand change
      this.loadEvs();
    }
  },
  computed: {
    loadedHH() {
      let hhInfo = this.pokerHandHistory(this.activeChatAccountName);
      if ((!hhInfo || !hhInfo.currently_viewing) && !this.loadingHand) {
        // no hand history -- trigger load the most recent one
        this.loadHand(-1);
        return null;
      }

      if (!hhInfo) return null;

      return hhInfo.currently_viewing;
    },
    currentHandId() {
      if (!this.apiHand) return null;
      return this.apiHand.hand_id;
    },
    apiHand() {
      if (!this.loadedHH) return {};
      return this.loadedHH.api_hand;
    },
    communityCards() {
      if (!this.loadedHH) return [];
      return this.decodeCards(this.apiHand.communityCards);
    },
    ...mapGetters([
      'activeChatAccountName',
      'pokerHandHistory',
    ]),
    ...mapState([
      'isDisconnected',
    ]),
    followMostRecent: {
      get () {
        let hhInfo = this.pokerHandHistory(this.activeChatAccountName);
        if (!hhInfo) {
          // default follow most recent
          return true;
        }

        return hhInfo.follow_most_recent;
      },
      set (value) {
        this.$store.commit("setFollowMostRecent", {displayID: this.activeChatAccountName, followMostRecent: value});
      },
    }
  },

  methods: {
    loadEvs() {
      let url = "/api/get_evs";

      let board = this.communityCards;
      let players = {};

      let nameById = {};

      for (let player of this.apiHand.players || []) {
        nameById[player.id] = player.nickname;
      }

      if (this.apiHand.result && this.apiHand.result.players_info) {
        for (let player of this.apiHand.result.players_info || []) {

          if (!player.shown || !player.shown.length) continue;

          players[nameById[player.playerId]] = player.shown;
        }
      }

      if (Object.keys(players).length < 2) {
        this.series = [];
        this.evDescription = "";
        return;
      }

      let handId = null;

      if (this.loadedHH) {
        handId = this.loadedHH._id;
      }

      this.$axios.post(url, {
        "players": players,
        "cards": board,
        "hand_id": handId
      }).then((res) => {
        const data = res.data;

        this.series = [];
        this.evDescription = "";

        if (data.is_interesting_hand) {
          this.evDescription = data.description;
        }

        for (let k of Object.keys(data.evs)) {
          let d = data.evs[k];

          this.series.push({
            name: k,
            data: [
              `${(d.pre_flop.ev*100).toFixed(1)}`,
              `${(d.flop.ev*100).toFixed(1)}`,
              `${(d.turn.ev*100).toFixed(1)}`,
              `${(d.river.ev*100).toFixed(1)}`]
          })
        }
      })
    },

    playersInHand(st) {
      let players = [];
      for (let k in st.players) {
        let p = st.players[k];
        if (p.result !== 0 && p.actions.length > 0) {
          players.push(p);
        }
      }
      return players;
    },
    getResult(st, p) {
      let d = st.settings.withDecimal ? 100 : 1;
      return (p.result / d).toFixed(2);
    },
    showed(st, p) {
      return (('' + p.seat) in st.showdowns) ;
    },

    loadHand(hand_num) {
      let nowMS = +(new Date());

      // loaded within last 2 seconds, don't load again
      if (nowMS - this.lastLoadedHand <= 2000) {
        return;
      }

      // already loading
      if (this.loadingHand) return;

      this.loadingHand = true;
      this.lastLoadedHand = +(new Date());

      // update tracking
      if (hand_num === -1) {
        // jumped to latest hand, follow most recent
        this.followMostRecent = true;
      } else {
        // we broke the cycle, don't follow last hand anymore
        this.followMostRecent = false;
      }

      let st = this.$store.state.states[this.activeChatAccountName];
      if (!st) {
        console.log("No state, can't load hand");
        this.loadingHand = false;
        return;
      }

      let room_id = st.room_id;
      let gameType = this.$store.getters.gameType(this.activeChatAccountName);
      this.$store.dispatch("loadHand", {displayID: this.activeChatAccountName, roomId: room_id, gameType: gameType, handNum: hand_num}).then(() => {
        this.loadingHand = false;
      }).catch(() => {
        this.loadingHand = false;
      });
    },

    seeTracker(hand) {
      this.askTracker = true;
      this.tracker = {...hand};
    },

    openAskShareHand(hand) {
      this.askShareHand = true;
      this.handSharing = {...hand};
    },

    shareHand() {
      this.$socket.emit(
          'share_hand',
          {
            displayID: this.handSharing.displayID,
            handSN: this.handSharing.hand_num,
            message: this.handSharing.message || "",
          }
      );
    },

    decodeCard(c) {
      return this.RANKS[c["rank"]] + this.SUITS[c["color"]];
    },

    decodeCards(cards) {
      if (!cards || !cards.length) return [];
      return cards.map(el => this.decodeCard(el));
    },
  }
}
</script>

<style scoped>
/*
.v-card {
  height: 60vh !important;
  max-height: 60vh;
  height: 100% !important;
  min-height: 300px;
  overflow-y: auto;
}
*/

.table-history {
  height: 100% !important;
  min-height: 300px;
  margin: 0;
}

.table-history > div {
  padding: 0;
}

.board {
  overflow: visible;

  padding: 10% 0 !important;
}

.share-hand {
  position: absolute;

  background-color: #639526 !important;

  top: -10px;
}
</style>
